module.exports = __webpack_public_path__ + "4ab8ce54925485804e52fa6e29bb63d4.mp4";